<!-- <mat-toolbar class="blue-theme">
  <img src="logo.png" alt="Logo" class="logo" /> 
  <span class="title">Vendor Portal</span>
  <span class="spacer"></span> 
  <div class="vendor-info" *ngIf="userName">
    <span class="vendor-name">Vendor Name: {{userName}}</span>
    <span class="vendor-code">Vendor Code: {{userCode}}</span>
  </div> 
</mat-toolbar> -->


<mat-toolbar class="white-theme header-toolbar">
  <div class="left-section">
    <img src="logo.png" alt="Logo" class="logo" />
    <span class="title">{{userType}} Portal</span>
  </div>

  <span class="spacer"></span>

  <div class="vendor-info" *ngIf="userName">
    <span class="vendor-name">{{userType}} Name: {{ userName }}</span>
    <span class="vendor-code">{{userType}} Code: {{ userCode }}</span>
  </div>
</mat-toolbar>

